import { selectBundleTabPage, selectQuery } from 'common/selectors';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom'; // or whatever router hook you use

type PresentingTabIndicatorProps = {
  currentPage: number;
};

export function usePresentingTabIndicator(
  { currentPage }: PresentingTabIndicatorProps = { currentPage: 1 },
) {
  const location = useLocation();
  const originalTitleRef = useRef<string>(document.title);
  const originalFaviconRef = useRef<string | null>(null);
  const docInfo = useSelector(selectQuery);
  const btpActive = useSelector(selectBundleTabPage);
  const getDocumentTitle: () => string = () => {
    if (btpActive && docInfo?.globalPagePrefix && docInfo?.tab) {
      return `${docInfo.globalPagePrefix} / ${docInfo.tab} / ${currentPage ?? ''}`;
    } else {
      return originalTitleRef.current as string;
    }
  };
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    const isPresenting = params.get('view') === 'share' && params.get('present') === 'public';

    document.title = getDocumentTitle()?.toUpperCase();

    const favicon: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") ||
      document.head.appendChild(Object.assign(document.createElement('link'), { rel: 'icon' }));

    if (originalFaviconRef.current === null) {
      originalFaviconRef.current = favicon.href;
    }

    if (isPresenting) {
      favicon.href = '/presenting.ico';
    } else if (originalFaviconRef.current) {
      favicon.href = originalFaviconRef.current;
    }

    return () => {
      document.title = originalTitleRef.current;
      if (originalFaviconRef.current) favicon.href = originalFaviconRef.current;
    };
  }, [location.search, currentPage, docInfo?.globalPagePrefix, docInfo?.tab, params]);
}
